<script setup>
import {usePage} from "@inertiajs/vue3";
import {nextTick, onMounted, watch} from "vue";

const page = usePage();

const dispatchFlash = (val) => {
    if (val?.text) {
        window.dispatchEvent(new CustomEvent('notify', {detail: val}));
    }
};

// `watch` (no `immediate`) only reacts to flash changes within a live layout.
// When a flash arrives on a navigation that swaps the layout (login lands on a
// DefaultLayout page, team switch, etc.) this component is freshly mounted, so
// the message is already present at creation and the watcher never fires — the
// onMounted dispatch covers that initial value. A persistent layout instead
// keeps this instance alive, so onMounted doesn't re-run and only the watcher
// fires; the two paths never double-dispatch the same message.
watch(() => page.props.flash?.message, dispatchFlash, {
    deep: true
});

// Defer the initial dispatch to the next tick: the sibling that registers the
// `notify` window listener (WithNotification) mounts after this component, so a
// synchronous dispatch here would fire before the listener exists and be lost.
// nextTick runs after the whole layout has mounted, guaranteeing the listener.
onMounted(() => nextTick(() => dispatchFlash(page.props.flash?.message)));
</script>

<template>
    <div />
</template>
